export default {"src":"/_next/static/media/icon-sanctuary-attach-apostle.9f983d87.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};